module.exports = "/images/ny-life2-1.jpg";